"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTablePaginationContainer = exports.StyledTable = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledTable = styled_components_1.default.div `
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: hidden;
  border-radius: 4px;
  background-color: ${ui_components_1.baseColors.white};

  && {
    table {
      font-size: 0.875rem;
      font-weight: 400;
      table-layout: fixed;
      max-width: 100%;
    }

    table td {
      height: 3.5rem;
      max-height: 3.5rem;
      box-sizing: border-box;
    }
  }
`;
exports.StyledTablePaginationContainer = styled_components_1.default.div `
  position: sticky;
  bottom: 0;
  left: 0;
  z-index: 5;
  background: ${ui_components_1.baseColors.white};
`;
